<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="fm1"></a><a id="page_3"></a><em>The man of system... is apt to be very wise in his own conceit; and is often so enamored with the supposed beauty of his own ideal plan of government, that he cannot suffer the smallest deviation from any part of it</em>.</p>
<p class="right">—Adam Smith</p>
<p class="noindent"><em>“Scientific socialism” would hold especial attraction for intellectuals by promising to replace spontaneous and messy life with a rational order of which they would be the interpreters and mentors</em>.</p>
<p class="right">—Richard Pipes</p>
<p class="noindent"><em>Here’s a good rule of thumb:<br/>Too clever is dumb</em>.</p>
<p class="right">—Ogden Nash<a id="page_4"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?73b4d9ca